import { Box, Flex } from "@chakra-ui/react"
import { EDITOR_MODE } from "@pathwright/blocks-engine"
import Removable from "@pathwright/blocks/src/shared/Removable"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import { PRIMARY_GRAY } from "@pathwright/ui/src/components/utils/colors"
import { useCallback, useEffect, useRef } from "react"
import AutosizeInput from "react-input-autosize"

const actionsGray = "gray"

export const Container = ({ children }) => {
  return (
    <Box boxShadow="0 0 20px 0 rgba(0, 0, 0, 0.1)" backgroundColor="#fff">
      {children}
    </Box>
  )
}

export const Item = (props) => {
  const {
    index,
    expanded,
    children,
    showControls,
    onRemove,
    onToggleExpand,
    onChangeTitle,
    DragHandle,
    mode,
    title: propsTitle
  } = props

  const contentRef = useRef(null)

  const title = propsTitle

  const handleChangeTitle = useCallback(
    (event) => {
      const nextTitle = event.target.value
      onChangeTitle({ index, attribute: "title", value: nextTitle })
    },
    [onChangeTitle, index]
  )

  useEffect(() => {
    if (expanded && contentRef.current) {
      // This causes unintended scrolling
      // contentRef.current.focus()
    }
  }, [expanded])

  return (
    <Box mb="1px" outline="1px solid rgba(0, 0, 0, 0.1)">
      <Flex
        onClick={onToggleExpand}
        onKeyDown={(e) => {
          if (e.key === " " || e.key === "Enter") {
            onToggleExpand()
          }
        }}
        role="button"
        aria-expanded={expanded}
        tabIndex={0}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        position="relative"
        padding="30px 20px"
        cursor="pointer"
      >
        {mode === EDITOR_MODE.EDIT ? (
          <Removable onRemove={onRemove}>
            {({ onRequestRemove }) => (
              <Flex w="100%" justify="space-between">
                {onChangeTitle ? (
                  <AutosizeInput
                    value={title}
                    style={{ overflowX: "auto" }}
                    onClick={(e) => e.stopPropagation()}
                    onChange={handleChangeTitle}
                    placeholder="Enter title..."
                    inputStyle={{
                      fontWeight: "bold",
                      // Specify color b/c of block styles
                      color: PRIMARY_GRAY,
                      outline: "none",
                      border: "none",
                      background: "none",
                      lineHeight: "1.4"
                    }}
                  />
                ) : (
                  <Text.H5>{title}</Text.H5>
                )}
                {mode === EDITOR_MODE.EDIT && (
                  <div className="AccordianItem__actions">
                    {showControls && DragHandle && (
                      <DragHandle>
                        {() => (
                          <span>
                            <Pathicon
                              icon="arrow-double-vertical-2"
                              style={{ color: actionsGray }}
                            />
                          </span>
                        )}
                      </DragHandle>
                    )}
                    {showControls && onRemove && (
                      <IconButton
                        icon="trash"
                        size={10}
                        style={{
                          marginRight: "-3px",
                          marginLeft: "10px",
                          width: "20px",
                          height: "16px",
                          color: actionsGray
                        }}
                        className="EditModeIcon"
                        onClick={(e) => {
                          e.stopPropagation()
                          onRequestRemove()
                        }}
                      />
                    )}
                  </div>
                )}
              </Flex>
            )}
          </Removable>
        ) : (
          <Flex w="100%" justify="space-between">
            <Text.H5>{title}</Text.H5>
          </Flex>
        )}
      </Flex>
      {expanded && (
        <Box
          ref={contentRef}
          padding="20px"
          padding-top="0"
          tabIndex={-1}
          role="region"
          aria-live="polite"
          aria-hidden={!expanded}
          sx={{
            ".ql-editor p,.ql-editor li": {
              // Ingore block styles text color
              color: "rgb(42, 46, 51) !important"
            }
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  )
}

export const Add = ({ onClick }) => (
  <Box
    onClick={onClick}
    padding="10px"
    outline="1px dashed rgba(0, 0, 0, 0.2)"
    cursor="pointer"
    bg="rgb(245, 245, 245)"
  >
    <IconButton icon="plus" className="EditModeIcon" />
  </Box>
)
